//NOTE: business logic example. Incomplete, please refer to requirements for further needed logic

let $ = require("jquery");
import _ from "underscore";
import render from "../../utilities/render";
import {
  setElementsFromScope
} from '../../utilities/selectorHelpers';

const customValidateProps = {
  errorPlacement: function(error, element) {
    let appendClosest = $(element).data('error-placement-append-closest');
    if (appendClosest) {
      $(element).closest(appendClosest).append(error);
    } else {
      error.insertAfter(element);
    }
  }
};

const elementsPageMap = {
  useAltAddressBtn: ".use-alt-address-btn",
  pageAltAddress: ".pickupAddress"
};

const elementsModalMap = {
  useAltBtn: ".use-alt-address-modal-btn",
  closeModalBtn: ".alt-address-modal-close-btn",
  addressForm: ".schedulePickUpAltAddress",

  modalSelects: ".select2-select",
  modalFields: "input",

  address1: ".scheduleReportAddress1",
  address2: ".scheduleReportAddress2",
  city: ".scheduleReportCity",
  state: ".scheduleReportState",
  zipcode: ".scheduleReportPostalCode"
};

const elementsFillableAreaMap = {
  pageAddress1: ".alt-address-st1",
  pageAddress2: ".alt-address-st2",
  pageCity: ".alt-address-city",
  pageState: ".alt-address-state",
  pageZipcode: ".alt-address-zip"
};

export default function AltAddressValidation(fillableAddressArea, {isExternal=false}={}) {
  const self = this;
  const schedPickupAddressOuter = $(".view-sched-pickup-address-outer");

  let modalEl;
  const elsPage = {};
  const elsModal = {};
  const elsFillablePage = {};

  self.init = function() {
    generateModal();
    setElements();
    bindElements();

    setupValidationForForm();

  };

  function generateModal() {
    let consumerClass = '';
    let btnClass = 'purple-btn';
    if(isExternal){
      consumerClass = 'consumer';
      btnClass = 'consumer-grey-btn';
    }
    const footerBtns = `<a href="#" class="base-btn v2-btn ${btnClass} alt-address-modal-close-btn">Cancel</a>\
    <a href="#" class="base-btn ${btnClass} use-alt-address-modal-btn">Use This Address</a>`;

    const bodyEl = render(
      require("./html/viewSchedulePickup/viewSchedulePickupAltAddressModal.html"), {
        consumerClass: consumerClass
      });

    modalEl = $(render(
      require("../../sharedHtml/modal.html"), {
        title: 'Use Alternative Address',
        subtitle: 'Add an alternative address to be the pickup destination.',
        footerBtns: footerBtns,
        body: bodyEl,
        modalBodyClass: 'q-bg-c-lightest-grey'
      }
    ));

    $("body").append(modalEl);
  };

  function bindElements() {
    elsPage.useAltAddressBtn.click(useAltAddressBtnClick);
    elsModal.useAltBtn.click(altAddressValidateClick);
    elsModal.closeModalBtn.click(closeModalClick);

    elsModal.modalSelects.change(validateIndividualSelects);
  };


  function setElements() {
    // set for page scope of general els
    setElementsFromScope(elsPage, elementsPageMap, schedPickupAddressOuter);
    // set for modal scope
    setElementsFromScope(elsModal, elementsModalMap, modalEl);
    // set for page level scope of fillable area
    setElementsFromScope(elsFillablePage, elementsFillableAreaMap, fillableAddressArea);
  };

  function setupValidationForForm() {
    elsModal.addressForm.validate(customValidateProps);
  };

  function altAddressValidateClick(e) {
    e.preventDefault();
    altAddressValidate();
  };

  function useAltAddressBtnClick(e) {
    e.preventDefault();

    handleModalShow();
  };

  function handleModalShow() {
    elsModal.addressForm.validate().resetForm();

    clearModalForm();

    modalEl.modal("show");
  };

  function altAddressValidate() {
    if (elsModal.addressForm.valid()) {
      modalEl.modal("hide");
      populateAlternateAddress();
      $("#pickup-availability").hide();
    }
  };

  function populateAlternateAddress() {
    const fillConfig = [{
        fromElement: elsModal.address1,
        toElement: elsFillablePage.pageAddress1
      },
      {
        fromElement: elsModal.address2,
        toElement: elsFillablePage.pageAddress2
      },
      {
        fromElement: elsModal.city,
        toElement: elsFillablePage.pageCity
      },
      {
        fromElement: elsModal.state.find("option:selected"),
        toElement: elsFillablePage.pageState
      },
      {
        fromElement: elsModal.zipcode,
        toElement: elsFillablePage.pageZipcode
      }
    ];
    updateSelectedPickupAddress();
    populateTextsFromElVals(fillConfig);
    fillableAddressArea.show();
    elsPage.pageAltAddress.prop("checked", true);
  };

  function populateTextsFromElVals(config) {
    _(config).map(populateTextFromElVal);
  };

  function updateSelectedPickupAddress() {
    $('#selected-pickup-address1').val(elsModal.address1.val());
    $('#selected-pickup-address2').val(elsModal.address2.val());
    $('#selected-pickup-city').val(elsModal.city.val());
    $('#selected-pickup-state').val(elsModal.state.find("option:selected").val());
    $('#selected-pickup-zip').val(elsModal.zipcode.val());
    $('#selected-pickup-country').val("US");
  }

  function populateTextFromElVal({
    toElement,
    fromElement
  }) {
    // if the from element is type option, then do our new code (text), otherwise use val
    let text;
    if (fromElement.is('option')) {
      text = fromElement.text();
    } else {
      text = fromElement.val();
    }

    toElement.text(text);
  };

  function validateIndividualSelects() {
    $(this).valid();
  };

  function clearModalForm(){
    elsModal.modalFields.val("");
    elsModal.modalSelects.val("").trigger("change.select2");
  };

  function closeModalClick(e) {
    e.preventDefault();

    modalEl.modal("hide");
  };
};



// WEBPACK FOOTER //
// ./src/pages/schedulePickup/viewAltAddressValidationLogic.js